import { renderToString } from "react-dom/server";

import { createImageIcon } from "@locators/components/shared/store-locator-icons";

import { PinHorecaIcon } from "@jti/brand-icons/pin-horeca";
import { UiTargetIcon } from "@jti/brand-icons/ui-target";

// Values used for fill are values of actual design tokens ie --des-color-fill-glyph-primary
export const USER_LOCATION = createImageIcon(renderToString(<UiTargetIcon width={43} height={43} fill="#747474ff" />));
export const DEFAULT_MARKER_LIGHT = createImageIcon(
  renderToString(<PinHorecaIcon width={30} height={30} fill={"#3a3d3f"} />)
);
export const DEFAULT_MARKER_DARK = createImageIcon(
  renderToString(<PinHorecaIcon width={30} height={30} fill={"#f5f5f5"} />)
);
export const ACTIVE_MARKER = createImageIcon(renderToString(<PinHorecaIcon width={38} height={38} fill="#3567FF" />));
